import { render, staticRenderFns } from "./IconUserSolid.vue?vue&type=template&id=6355faa5"
import script from "./IconUserSolid.vue?vue&type=script&lang=js"
export * from "./IconUserSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports